<template>
  <v-container class="px-5 py-0 ma-0">
    <v-form
      ref="appForm"
    >
      <v-subheader>{{ lang.config.app.form.title }}</v-subheader>
      <v-row>
        <v-text-field
          :value="lang.meta.app_title"
          :label="lang.config.app.form.app_title"
          autocomplete="new-password"
          filled
          hide-details
          disabled
          class="pb-3"
        ></v-text-field>
      </v-row>
      <v-row>
        <v-text-field
          :value="app_data.socket_server"
          :label="lang.config.app.info.server"
          autocomplete="new-password"
          filled
          hide-details
          disabled
          class="pb-3"
        ></v-text-field>
      </v-row>
      <v-row>
        <v-btn
          color="success"
          class="mt-4 save-btn"
          disabled
        >
          {{ lang.config.save }}
        </v-btn>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  mixins: [ appdata, utils ]
}
</script>
